import React, { useState, useContext } from "react";
import { useSnackbar } from "notistack";
import Axios from "axios";
import FormData from "form-data";
import { DatabaseContext } from "./DatabaseContext";

export const UserContext = React.createContext();

const BLANK_USER = {
  Site: {
    theme: "dark",
  },
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(BLANK_USER);
  const { apiUrl, token, changeToken } = useContext(DatabaseContext);
  const { enqueueSnackbar } = useSnackbar();
  const [Allfiltersites1, setAllFilerSites1] = useState([]);

  const login = async (email, password) => {
    try {
      const res = await Axios.post(
        `${apiUrl}/api/auth/login`,
        {
          username: email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-app-id": "fa6d22e8-91cb-4b72-8d14-36ef8e58ba92-IDCapturePortal", // Replace with your actual App ID variable or string
          },
          withCredentials: true,
        },
      );

      if (res.data.success) {
        enqueueSnackbar("Login Successful", {
          variant: "success",
          autoHideDuration: 3000,
          style: { fontSize: "15px" },
        });

        localStorage.setItem("token", res.data.token);
        localStorage.setItem("email", email);
        //localStorage.setItem("user", res.data.us);
        changeToken(res.data.token);
        setUser(BLANK_USER);

        return res.data;
      } else if (res.data.firstTime) {
        return res.data;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
        changeToken(null);
        localStorage.removeItem("token");
        setUser(BLANK_USER);
        return false;
      }
    } catch (err) {
      const serverErrorMessage =
        err.response?.data?.error || err.message || "Internal Server Error";
      enqueueSnackbar(
        token == null
          ? "Authorization Token is not set, please try to login again"
          : serverErrorMessage,
        {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        },
      );
      throw err;
    }
  };

  const getMe = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await Axios.get(`${apiUrl}/api/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        const {
          id,
          siteCode,
          displayName,
          email,
          telephone,
          userRole,
          currentSite,
          showCampaigns,
          LastPasswordUpdateDate,
          DaysToResetPassword,
          AutoUpdatePasswordAllowed,
          Password1,
          Password2,
        } = res.data.data[0][0];

        let Site;

        // set Site to currentSite

        const resSites = await Axios.get(`${apiUrl}/api/sites`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (userRole === "admin") {
          if (resSites.data.success) {
            Site = resSites.data.data[0].filter(
              (singleSite) => singleSite.siteCode === currentSite,
            );
          } else {
            Site = resSites.data.data[0];
          }
        } else {
          Site = resSites.data.data[0].filter(
            (singleSite) => singleSite.siteCode === currentSite,
          );
        }

        const User = {
          id,
          siteCode,
          displayName,
          email,
          telephone,
          userRole,
          currentSite,
          showCampaigns,
          Sites:
            userRole === "admin"
              ? resSites.data.data[0]
              : resSites.data.data[0].length > 0
                ? resSites.data.data[0]
                : Site,
          LastPasswordUpdateDate,
          DaysToResetPassword,
          AutoUpdatePasswordAllowed,
          Password1,
          Password2,
          Site: Site[0],
        };

        setUser(User);

        return User;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
      throw err.message;
    }
  };

  const logout = async () => {
    try {
      const res = await Axios.get(`${apiUrl}/api/auth/logout`);
      if (res.data.success) {
        changeToken(null);
        //localStorage.removeItem("token");  // 20240123  SJB Login fails if token is cleared
        localStorage.removeItem("WondeID");
        localStorage.removeItem("email");
        setUser(BLANK_USER);
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
      });
      throw err.message;
    }
  };

  const signUpRequest = async ({
    email,
    siteCode,
    siteName,
    siteType,
    message,
  }) => {
    try {
      const res = await Axios.post(`${apiUrl}/api/auth/signuprequest`, {
        email,
        siteCode,
        siteName,
        siteType,
        message,
      });
      if (res.data.success) {
        return res.data;
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
      });
      throw err.message;
    }
  };

  const registerUser = async ({
    siteCode,
    displayName,
    email,
    password,
    telephone,
    userRole,
    showCampaigns,
  }) => {
    try {
      const res = await Axios.post(`${apiUrl}/api/auth/register`, {
        SiteSiteCode: siteCode,
        displayName,
        email,
        password,
        telephone,
        userRole,
        showCampaigns,
      });

      if (res.data.success) {
        enqueueSnackbar("Successfully registered user", { variant: "success" });
        return res.data.token;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const forgotPassword = async (email) => {
    try {
      const res = await Axios.post(
        `${apiUrl}/api/auth/forgotpassword`,
        {
          email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-app-id": "fa6d22e8-91cb-4b72-8d14-36ef8e58ba92-IDCapturePortal", // Replace with your actual App ID variable or string
          },
        },
      );

      if (res.data.success) {
        enqueueSnackbar(`Password reset link has been emailed to ${email}`, {
          variant: "success",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
        return res.data;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const resetPassword = async (password, resetToken) => {
    try {
      const res = await Axios.put(
        `${apiUrl}/api/auth/resetpassword/${resetToken}`,
        {
          password,
        },
      );
      if (res.data.success) {
        enqueueSnackbar("Password reset", {
          variant: "success",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const createUser = async (user) => {
    try {
      const res = await Axios.post(`${apiUrl}/api/users`, user);
      if (res.data.success) {
        enqueueSnackbar("User created", { variant: "success" });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const changeSite = async (siteCode) => {
    try {
      // 1. Use the local state 'user.id' instead of making a stale API call to /api/auth/me
      if (!user || !user.id) {
        enqueueSnackbar("User session not found. Please log in again.", {
          variant: "error",
        });
        return;
      }

      const token = localStorage.getItem("token");
      let selectedSite;

      // 2. Grab the sites list to find our new target site metadata
      const resSites = await Axios.get(`${apiUrl}/api/sites`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (resSites.data.success) {
        selectedSite = resSites.data.data[0].filter(
          (singleSite) => singleSite.siteCode === siteCode,
        );
      }

      if (!selectedSite || selectedSite.length === 0) {
        enqueueSnackbar("Selected site could not be resolved.", {
          variant: "error",
        });
        return;
      }

      // 3. Update the database FIRST
      const res = await Axios.put(`${apiUrl}/api/users/${user.id}`, {
        currentSite: siteCode,
      });

      // 4. ONLY update local React state if the database confirms success
      if (res.data.success) {
        setUser((currentUser) => ({
          ...currentUser,
          currentSite: siteCode,
          Site: selectedSite[0],
          Sites:
            currentUser.userRole === "admin"
              ? currentUser.Sites
              : currentUser.Sites.length > 1
                ? currentUser.Sites
                : selectedSite,
        }));

        enqueueSnackbar(`Changed site to ${selectedSite[0].name}`, {
          variant: "success",
          autoHideDuration: 4000,
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response?.data?.error || err.message, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  // User Change Password
  const changePassword = async (
    currentPassword,
    newPassword,
    confirmNewPassword,
  ) => {
    try {
      if (newPassword !== confirmNewPassword) {
        enqueueSnackbar(`Passwords don't match`, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
        return;
      }
      await Axios.put(`${apiUrl}/api/auth/updatepassword`, {
        currentPassword,
        newPassword,
      });
      enqueueSnackbar("Password updated", {
        variant: "success",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const getAllUsers = async () => {
    try {
      const res = await Axios.get(`${apiUrl}/api/users`);
      if (res.data.success) {
        return res.data.data[0];
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const getUser = async (id) => {
    try {
      const res = await Axios.get(`${apiUrl}/api/users/${id}`);
      if (res.data.success) {
        return res.data.data;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const updateUser = async (id, user) => {
    try {
      const res = await Axios.put(`${apiUrl}/api/users/${id}`, user);
      if (res.data.success) {
        enqueueSnackbar(`Updated user ${id}`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const deleteUser = async (id) => {
    try {
      const res = await Axios.delete(`${apiUrl}/api/users/${id}`);
      if (res.data.success) {
        enqueueSnackbar(`Deleted user ${id}`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const getAllSites = async () => {
    try {
      const res = await Axios.get(`${apiUrl}/api/sites`);

      if (res.data.success) {
        return res.data.data[0];
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const createSite = async (site) => {
    try {
      const res = await Axios.post(`${apiUrl}/api/sites`, site);
      if (res.data.success) {
        enqueueSnackbar(`Created site ${site.siteCode}`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const updateSite = async (siteCode, site) => {
    try {
      const res = await Axios.put(`${apiUrl}/api/sites/${siteCode}`, site);
      if (res.data.success) {
        enqueueSnackbar(`Updated site ${siteCode}`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const deleteSite = async (siteCode) => {
    try {
      const res = await Axios.delete(`${apiUrl}/api/sites/${siteCode}`);
      if (res.data.success) {
        enqueueSnackbar(`Deleted site ${siteCode}`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const uploadSiteLogo = async (siteCode, logo) => {
    let form = new FormData();
    form.append("logo", logo);
    try {
      const res = await Axios.put(`${apiUrl}/api/sites/${siteCode}/logo`, form);
      if (res.data.success) {
        enqueueSnackbar(`Updated logo`, {
          variant: "success",
          style: { fontSize: "15px" },
        });
        return res.data.data;
      } else {
        enqueueSnackbar(res.data.error.data.error, {
          variant: "error",
          autoHideDuration: 6000,
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
      throw err.message;
    }
  };

  const getSearchSites = async (filterColumn, filterValue) => {
    try {
      const res = await Axios.get(
        `${apiUrl}/api/library/search/?filterColumn=${filterColumn}&filterValue=${filterValue}`,
      );
      setAllFilerSites1(res.data.data[0]);
      return res.data.data[0];
    } catch (error) {
      enqueueSnackbar(`Couldn't get sites: ${error.message}`, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const getSearchUsers = async (filterColumn, filterValue) => {
    try {
      const res = await Axios.get(
        `${apiUrl}/api/library/users/search/?filterColumn=${filterColumn}&filterValue=${filterValue}`,
      );
      return res.data.data[0];
    } catch (error) {
      enqueueSnackbar(`Couldn't get users: ${error.message}`, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUser((s) => ({ ...s, [name]: value }));
  };

  const handleSiteChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      setUser((s) => ({ ...s, Site: { ...s.Site, [name]: checked } }));
    } else {
      setUser((s) => ({ ...s, Site: { ...s.Site, [name]: value } }));
    }
  };

  const handleThemeChange = () => {
    if (user.Site.theme === "dark") {
      setUser((s) => ({ ...s, Site: { ...s.Site, theme: "light" } }));
    } else {
      setUser((s) => ({ ...s, Site: { ...s.Site, theme: "dark" } }));
    }
  };

  const UpdateUserPassword = async (password) => {
    try {
      const res = await Axios.put(
        `${apiUrl}/api/auth/SubmitUpdatePassword?email=${user.email}`,
        {
          password,
        },
      );

      if (res.data.success === true) {
        return res.data;
      }
      enqueueSnackbar("Password updated", {
        variant: "success",
        style: { fontSize: "15px" },
      });
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const resetUsersPassword = async (password, userEmail) => {
    try {
      const res = await Axios.put(
        `${apiUrl}/api/auth/SubmitUpdatePassword?email=${userEmail}`,
        {
          password,
        },
      );

      if (res.data.success === true) {
        enqueueSnackbar("Password updated", {
          variant: "success",
          style: { fontSize: "15px" },
        });
        return res.data;
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const ReSendAuthCode = async (id) => {
    try {
      const res = await Axios.put(`${apiUrl}/api/auth/resendAuthCode`, {
        id,
      });
      if (res.data.success === true) {
        enqueueSnackbar("Code resent to your email", {
          variant: "success",
          style: { fontSize: "15px" },
        });
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  const VerifyCode = async (id, code) => {
    try {
      const res = await Axios.put(`${apiUrl}/api/auth/verifyAuthEmailCode`, {
        id,
        code,
      });
      if (res.data.success === true) {
        return res.data;
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "15px" },
      });
    }
  };

  return (
    <UserContext.Provider
      value={{
        ...user,
        token,
        login,
        logout,
        getMe,
        changeSite,
        registerUser,
        signUpRequest,
        createUser,
        forgotPassword,
        resetPassword,
        changePassword,
        getAllUsers,
        getUser,
        updateUser,
        deleteUser,
        getAllSites,
        createSite,
        updateSite,
        deleteSite,
        uploadSiteLogo,
        handleUserChange,
        handleSiteChange,
        handleThemeChange,
        Allfiltersites1,
        getSearchSites,
        getSearchUsers,
        UpdateUserPassword,
        ReSendAuthCode,
        VerifyCode,
        resetUsersPassword,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
